const avatarBlacklist = new Set(['KZ', 'HJ', 'NS', 'SA', 'SS', 'HH', 'AH']);
export function calculateAvatarAbbreviation(string = '') {
  const startingLetters = string.split(' ').map(word => word.trim()[0]?.toUpperCase()).filter(Boolean);
  if (startingLetters.length === 0) {
    return '';
  }
  const abbreviation = `${startingLetters[0]}${startingLetters.length > 1 ? startingLetters.at(-1) : ''}`;
  return avatarBlacklist.has(abbreviation) ? abbreviation[0] : abbreviation;
}